(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var value = (Number(cents) / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* Match Impulse header stack for hero height */
  function syncHeaderOffset() {
    if (!document.body.classList.contains('tee-house-dark-page')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var top = Math.round(main.getBoundingClientRect().top);
    if (top > 40) {
      document.body.style.setProperty('--thd-header-h', top + 'px');
    }
  }
  syncHeaderOffset();
  window.addEventListener('resize', syncHeaderOffset);
  window.addEventListener('load', syncHeaderOffset);

  /* Mobile nav */
  var menuBtn = qs('[data-thd-menu]');
  var mobileNav = qs('[data-thd-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = !mobileNav.classList.contains('is-open');
      mobileNav.classList.toggle('is-open', open);
      mobileNav.hidden = !open;
      menuBtn.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  /* Language / country-currency disclosures */
  qsa('[data-thd-disclosure]').forEach(function (disclosure) {
    var toggle = qs('[data-thd-disclosure-toggle]', disclosure);
    var list = qs('[data-thd-disclosure-list]', disclosure);
    var input = qs('[data-thd-disclosure-input]', disclosure);
    var form = disclosure.closest('[data-thd-loc-form]') || disclosure.closest('form');
    if (!toggle || !list || !input || !form) return;

    function closeList() {
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    function openList() {
      qsa('[data-thd-disclosure-list]').forEach(function (other) {
        if (other !== list) {
          other.hidden = true;
          var otherToggle = qs('[data-thd-disclosure-toggle]', other.closest('[data-thd-disclosure]'));
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });
      list.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      if (list.hidden) openList();
      else closeList();
    });

    qsa('[data-thd-disclosure-option]', disclosure).forEach(function (option) {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        var value = option.getAttribute('data-value');
        if (!value) return;
        input.value = value;
        form.submit();
      });
    });

    disclosure.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        closeList();
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!disclosure.contains(event.target)) closeList();
    });
  });

  /* Smooth scroll anchors */
  qsa('[data-thd-scroll]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = qs(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (mobileNav) mobileNav.classList.remove('is-open');
    });
  });

  /* Gallery + lightbox (thumbs stay compact; lightbox only on demand) */
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseGalleryMedia(gallery) {
    var node = qs('[data-thd-gallery-json]', gallery);
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function ensureLightbox() {
    var existing = qs('[data-thd-lightbox]');
    if (existing) return existing;

    var root = document.createElement('div');
    root.className = 'thd-lightbox';
    root.setAttribute('data-thd-lightbox', '');
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="thd-lightbox__backdrop" data-thd-lightbox-close></div>' +
      '<div class="thd-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Product gallery">' +
        '<button type="button" class="thd-lightbox__close" data-thd-lightbox-close aria-label="Close gallery">×</button>' +
        '<button type="button" class="thd-lightbox__nav thd-lightbox__nav--prev" data-thd-lightbox-prev aria-label="Previous image">‹</button>' +
        '<div class="thd-lightbox__stage" data-thd-lightbox-stage></div>' +
        '<button type="button" class="thd-lightbox__nav thd-lightbox__nav--next" data-thd-lightbox-next aria-label="Next image">›</button>' +
        '<p class="thd-lightbox__count" data-thd-lightbox-count></p>' +
      '</div>';
    document.body.appendChild(root);
    return root;
  }

  function bindSwipe(el, onSwipe) {
    if (!el || typeof onSwipe !== 'function') return;
    var startX = 0;
    var startY = 0;
    var tracking = false;

    el.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      tracking = true;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    el.addEventListener('touchend', function (event) {
      if (!tracking || !event.changedTouches || !event.changedTouches.length) return;
      tracking = false;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      onSwipe(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  qsa('[data-thd-gallery]').forEach(function (gallery) {
    var main = qs('[data-thd-gallery-main]', gallery);
    var stage = qs('[data-thd-gallery-stage]', gallery);
    var thumbs = qsa('[data-thd-gallery-thumb]', gallery);
    var openBtns = qsa('[data-thd-gallery-open]', gallery);
    var prevBtn = qs('[data-thd-gallery-prev]', gallery);
    var nextBtn = qs('[data-thd-gallery-next]', gallery);
    var media = parseGalleryMedia(gallery);
    var index = 0;
    var lightbox = null;
    var suppressOpen = false;

    if (!main || !stage) return;

    function renderStage(item) {
      if (!item) return;
      if (item.type === 'video') {
        stage.innerHTML =
          '<video src="' + escapeHtml(item.src) + '"' +
          (item.poster ? ' poster="' + escapeHtml(item.poster) + '"' : '') +
          ' controls playsinline muted></video>';
      } else {
        stage.innerHTML =
          '<img src="' + escapeHtml(item.src) + '" alt="' + escapeHtml(item.alt) + '" width="1600" height="1600">';
      }
      main.classList.toggle('has-video', item.type === 'video');
    }

    function setActiveThumb(i) {
      thumbs.forEach(function (t) {
        var ti = parseInt(t.getAttribute('data-index'), 10);
        t.classList.toggle('is-active', ti === i);
      });
    }

    function showAt(i) {
      if (!media.length) return;
      index = ((i % media.length) + media.length) % media.length;
      renderStage(media[index]);
      setActiveThumb(index);
      if (lightbox && !lightbox.hasAttribute('hidden')) {
        renderLightboxStage();
      }
    }

    function renderLightboxStage() {
      if (!lightbox) return;
      var lbStage = qs('[data-thd-lightbox-stage]', lightbox);
      var count = qs('[data-thd-lightbox-count]', lightbox);
      var item = media[index];
      if (!lbStage || !item) return;
      if (item.type === 'video') {
        lbStage.innerHTML =
          '<video src="' + escapeHtml(item.src) + '"' +
          (item.poster ? ' poster="' + escapeHtml(item.poster) + '"' : '') +
          ' controls playsinline autoplay></video>';
      } else {
        lbStage.innerHTML =
          '<img src="' + escapeHtml(item.src) + '" alt="' + escapeHtml(item.alt) + '">';
      }
      if (count) count.textContent = (index + 1) + ' / ' + media.length;
      var prev = qs('[data-thd-lightbox-prev]', lightbox);
      var next = qs('[data-thd-lightbox-next]', lightbox);
      if (prev) prev.hidden = media.length < 2;
      if (next) next.hidden = media.length < 2;
    }

    function onKeydown(event) {
      if (!lightbox || lightbox.hasAttribute('hidden')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showAt(index - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showAt(index + 1);
      }
    }

    function openAt(i) {
      if (!media.length) return;
      index = ((i % media.length) + media.length) % media.length;
      lightbox = ensureLightbox();
      lightbox._thdOwner = {
        prev: function () { showAt(index - 1); },
        next: function () { showAt(index + 1); },
        close: closeLightbox
      };
      lightbox.removeAttribute('hidden');
      document.body.classList.add('thd-lightbox-open');
      setActiveThumb(index);
      renderLightboxStage();
      document.addEventListener('keydown', onKeydown);

      if (!lightbox._thdBound) {
        lightbox._thdBound = true;
        lightbox.addEventListener('click', function (event) {
          var owner = lightbox._thdOwner || {};
          var t = event.target;
          if (t.closest('[data-thd-lightbox-close]') && owner.close) owner.close();
          if (t.closest('[data-thd-lightbox-prev]') && owner.prev) owner.prev();
          if (t.closest('[data-thd-lightbox-next]') && owner.next) owner.next();
        });
        bindSwipe(lightbox, function (dir) {
          var owner = lightbox._thdOwner;
          if (!owner) return;
          if (dir > 0 && owner.next) owner.next();
          if (dir < 0 && owner.prev) owner.prev();
        });
      }
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.setAttribute('hidden', '');
      document.body.classList.remove('thd-lightbox-open');
      document.removeEventListener('keydown', onKeydown);
      var lbStage = qs('[data-thd-lightbox-stage]', lightbox);
      if (lbStage) lbStage.innerHTML = '';
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.getAttribute('data-index'), 10);
        if (isNaN(i)) return;
        showAt(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showAt(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showAt(index + 1);
      });
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (suppressOpen) {
          suppressOpen = false;
          return;
        }
        var i = parseInt(btn.getAttribute('data-index'), 10);
        if (isNaN(i)) i = index;
        openAt(i);
      });
    });

    bindSwipe(main, function (dir) {
      if (media.length < 2) return;
      suppressOpen = true;
      showAt(index + dir);
      setTimeout(function () { suppressOpen = false; }, 0);
    });

    if (media[0]) main.classList.toggle('has-video', media[0].type === 'video');
  });

  /* Quantity steppers */
  qsa('[data-thd-qty]').forEach(function (wrap) {
    var input = qs('input', wrap);
    var minus = qs('[data-thd-qty-minus]', wrap);
    var plus = qs('[data-thd-qty-plus]', wrap);
    if (!input) return;

    function clamp(n) {
      n = parseInt(n, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }

    if (minus) {
      minus.addEventListener('click', function () {
        input.value = String(Math.max(1, clamp(input.value) - 1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = String(clamp(input.value) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  /* Sync quantity across forms */
  qsa('input[name="quantity"][data-thd-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var val = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = String(val);
      qsa('input[name="quantity"][data-thd-qty-input]').forEach(function (other) {
        if (other !== input) other.value = String(val);
      });
    });
  });

  /* Sticky ATC */
  var sticky = qs('[data-thd-sticky]');
  var productAnchor = qs('#thd-product');
  if (sticky && productAnchor) {
    document.body.classList.add('thd-sticky-pad');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      { rootMargin: '-80px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(productAnchor);
  }

  function toast(message) {
    var el = qs('[data-thd-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'thd-toast';
      el.setAttribute('data-thd-toast', '');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2200);
  }

  function updateCartCount(count) {
    qsa('[data-thd-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = !count;
    });
  }

  /* Add to cart */
  qsa('[data-thd-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var submitBtn = qs('[type="submit"]', form);
      var idInput = qs('[name="id"]', form);
      var qtyInput = qs('[name="quantity"]', form) || qs('input[name="quantity"][data-thd-qty-input]');
      if (!idInput) return;

      var payload = {
        items: [{
          id: Number(idInput.value),
          quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1)
        }]
      };

      if (submitBtn) {
        submitBtn.disabled = true;
      }

      fetch((window.thd && thd.routes && thd.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          window.location.href = (window.thd && thd.routes && thd.routes.checkout) || '/checkout';
        })
        .catch(function () {
          toast('Could not add to cart');
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });

  /* Initial cart count */
  fetch((window.thd && thd.routes && thd.routes.cartJs) || '/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count || 0);
    })
    .catch(function () {});

  /* Expose money helper for liquid-fed price nodes if needed */
  window.thd = window.thd || {};
  window.thd.formatMoney = formatMoney;
})();
